'use strict';

var _util = require('../../util');

var map = {
    'ar-ma': 'ar-ma',
    'de-de': 'de-de',
    'en-us': 'en-us',
    'es-es': 'es-es',
    'fr-fr': 'fr-fr',
    'id-id': 'id-id',
    'in-id': 'in-id',
    'it-it': 'it-it',
    'ja-jp': 'ja-jp',
    'ko-kr': 'ko-kr',
    'nl-nl': 'nl-nl',
    'pt-br': 'pt-br',
    'pt-pt': 'pt-pt',
    'ru-ru': 'ru-ru',
    'th-th': 'th-th',
    'tr-tr': 'tr-tr',
    'vi-vn': 'vi-vn',
    'zh-cn': 'zh-cn',
    'iw-il': 'iw-il',
    'pl-pl': 'pl-pl',
    'uk-ua': 'uk-ua'
};

var i18n = {
    'ar-ma': require('./ar-ma'),
    'de-de': require('./de-de'),
    'en-us': require('./en-us'),
    'es-es': require('./es-es'),
    'fr-fr': require('./fr-fr'),
    'id-id': require('./id-id'),
    'in-id': require('./in-id'),
    'it-it': require('./it-it'),
    'ja-jp': require('./ja-jp'),
    'ko-kr': require('./ko-kr'),
    'nl-nl': require('./nl-nl'),
    'pt-br': require('./pt-br'),
    'pt-pt': require('./pt-pt'),
    'ru-ru': require('./ru-ru'),
    'th-th': require('./th-th'),
    'tr-tr': require('./tr-tr'),
    'vi-vn': require('./vi-vn'),
    'zh-cn': require('./zh-cn'),
    'iw-il': require('./iw-il'),
    'pl-pl': require('./pl-pl'),
    'uk-ua': require('./uk-ua')
};

function _(locale) {
    var r = i18n[map[locale] || 'en-us'];
    r._ = _;
    return r;
}

var locale = (0, _util.getLocale)();
module.exports = _(locale);